module.exports = __webpack_public_path__ + "img/orange_textful.0fb4b864.svg";